import Head from "@app/components/Head";
import Info from "@app/components/Info";
import { getSubmissionStatus } from "src/helpers/submissionStatus";

function contact() {
  return (
    <>
      <Head options={{ title: "Contact" }} />
      <Info />;
    </>
  );
}

export async function getServerSideProps() {
  return {
    props: {
      submissionStatus: await getSubmissionStatus(),
    },
  };
}

export default contact;
